export const FEEDBACK_GROUP_ID = 'JSW Summary Page';
